import { AuthEntry } from 'views/auth/AuthEntry';
import { SignupPlan } from 'views/auth/signup/Plan';
import { SignupPlanReadonly } from 'views/auth/signup/PlanReadonly';
import { AcceptInvitation } from 'views/auth/accept-invitation';
import { EmailConfirmed } from 'views/auth/email-confirmed';
import { ResetPassword } from 'views/auth/signin/resetpassword';
import { SignupVerification } from 'views/auth/signup/verify';

const Routes = [
  {
    path: '/register/plan',
    view: SignupPlan,
    layout: 'plain',
    permission: 'owner',
    requireNoActivePlan: true,
    title: 'Register to UrbanMetrix',
  },
  {
    path: '/register/plan-readonly',
    view: SignupPlanReadonly,
    layout: 'plain',
    permission: 'editor',
    requireNoActivePlan: true,
    title: 'Register to UrbanMetrix',
  },
  {
    path: '/register/verify',
    view: SignupVerification,
    layout: 'auth',
    permission: 'editor',
    title: 'Please verify your email address',
  },
  {
    path: '/accept-invitation',
    view: AcceptInvitation,
    layout: 'auth',
    title: 'Accept Invitation',
  },
  {
    path: '/email-confirmed',
    view: EmailConfirmed,
    layout: 'auth',
    title: 'Email Confirmed',
  },
  {
    path: '/login',
    view: AuthEntry,
    layout: 'auth',
    title: 'Welcome to UrbanMetrix',
  },
  {
    path: '/resetpassword',
    view: ResetPassword,
    layout: 'auth',
    title: 'Reset Your Password',
  },
];

export default Routes;
